import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
  ],
});

export const styles = StyleSheet.create({
  page: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '100%',
    paddingBottom: 60,
  },
  leftColumn: {
    width: '40%',
    height: '100%',
    backgroundColor: 'white',
    color: 'white',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: 53,
    paddingBottom: 80,
    paddingRight: 0,
  },
  rightColumn: {
    width: '60%',
    height: '100%',
    backgroundColor: 'white',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: 53,
    paddingTop: 46,
    paddingBottom: 80,
    paddingLeft: 20,
    gap: 20,
  },

  title: {
    color: 'black',
    fontFamily: 'Lato',
    fontSize: 40,
    fontWeight: 900,
    lineHeight: 1.4,
    textTransform: 'uppercase',

    width: '60%',
  },
  text: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 1.4,
    width: '75%',
  },

  paragraphBold: {
    fontWeight: 900,
    paddingRight: 10,
  },

  itemWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 10,

    backgroundColor: '#f5f5f5',
    borderRadius: 6,

    paddingVertical: 40,
    paddingHorizontal: 40,

    width: '100%',
    height: 290,
  },

  itemContentWrapper: {
    width: '100%',
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
  },

  itemTitle: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 18,
    fontWeight: 700,
    marginTop: 20,
  },
  logoImage: {
    width: 'auto',
    height: 80,
    objectFit: 'contain',
  },
  button: {
    paddingVertical: 10,
    paddingHorizontal: 15,
    borderRadius: 8,
    fontSize: 14,
    textDecoration: 'none',
    textAlign: 'center',
  },
});
